/** @desc eventId和唯一key的映射表 */
import Feed from './feed'
import Store from './store'

export const eventMap = {
  ...Feed,
  ...Store,
}
